<div @enterFadeIn>
  <div class="my-1 flex items-center justify-between gap-2">
    <div class="flex-1">
      <div class="flex flex-col gap-1">
        <span class="truncate font-medium">{{ workplace()?.name }}</span>
        @if (workplace()?.address) {
          <div class="text-address">
            @if (workplace()?.address?.line1) {
              <span>{{ workplace()?.address?.line1 }}</span>
            }
            @if (workplace()?.address?.line2) {
              <span class="ms-1">{{ workplace()?.address?.line2 }}</span>
            }
            @if (workplace()?.address?.postalCode) {
              <span class="ms-1">{{ workplace()?.address?.postalCode }}.</span>
            }
            @if (workplace()?.address?.city) {
              <span class="ms-1">{{ workplace()?.address?.city }}.</span>
            }
            @if (workplace()?.address?.countryName) {
              <span class="ms-1">{{ workplace()?.address?.countryName }}.</span>
            }
          </div>
        }
      </div>
    </div>
    <div>
      <ng-container *ngTemplateOutlet="iconActions" />
    </div>
  </div>
</div>

<ng-template #iconActions>
  <button
    mat-icon-button
    color="blue"
    matTooltip="Editar"
    i18n-matTooltip
    (click)="goToWorkplaceUpdate()">
    <mat-icon>edit</mat-icon>
  </button>
</ng-template>
